module.exports = __webpack_public_path__ + "img/logo_text_fr.ffd2a66a.png";